import { FetchAPI } from "@renedelangel/helpers";

import { urlServidor } from '../../../helpers';

import { UPDATE_ESTATUS, UPDATE_PASSWORD } from '../index';

export const updateEstatus = async (variables, token) => {
    try {

        let { updateEstatus } = await FetchAPI.graphql({
            token,
            variables,
            url: urlServidor,
            query: UPDATE_ESTATUS
        });

        return updateEstatus;

    } catch({message}) { throw new Error(message); }
};

export const updatePassword = async (variables, token) => {
    try {

        let { updatePassword } = await FetchAPI.graphql({
            token,
            variables,
            url: urlServidor,
            query: UPDATE_PASSWORD
        });

        return updatePassword;

    } catch({message}) { throw new Error(message); }
};
